import UserPhotos from './UserPhotos';

export default UserPhotos;
